export default {
  index: 'banking-operations-list-view',
  store: 'banking-operations-create-view',
  edit: 'banking-operations-edit-view',
  settle: 'banking-operations-settle-view',
  manually_settle: 'banking-operations-manually-settle-view', //todo change to popup when more than popup will be avaible on data-grid
};
